import logEvent from '../utils/logEvent';
const android = 'android';
const ios = 'ios';
const web = 'web';
const platform = navigator.userAgent.includes('becon_ios')
  ? ios
  : navigator.userAgent.includes('becon_android')
  ? android
  : web;

export function getLanguage() {
  switch (platform) {
    case android:
      try {
        window.Becon.requestAction(
          'getLanguage',
          'getLanguage',
          JSON.stringify({}),
        );
      } catch (e) {
        console.log('android Error (' + e.toString() + ')');
      }
      break;
    case ios:
      try {
        window.webkit.messageHandlers.getLanguage.postMessage('');
      } catch (e) {
        console.log('ios Error (' + e.toString() + ')');
      }
      break;
    default:
      break;
  }
}

export function clearHistory() {
  switch (platform) {
    case ios:
      try {
        window.webkit.messageHandlers.clearHistory.postMessage('');
      } catch (e) {
        console.log('ios Error (' + e.toString() + ')');
      }
      break;
    default:
      console.log('Request clearHistory');
      break;
  }
}

// action: String, authParam: String
// 여기
export function startDiagnosis(action, authParam) {
  const activityParam = JSON.stringify({
    name: action,
  });
  switch (platform) {
    case android:
      try {
        window.Becon.requestAction('goToActivity', action, activityParam);
        window.Becon.requestAction('setAuth', action + '-auth', authParam);
      } catch (e) {
        console.log('android Error (' + e.toString() + ')');
      }
      break;
    case ios:
      try {
        // window.webkit.messageHandlers.goTo.postMessage({ activityParam });
        window.webkit.messageHandlers.goTo.postMessage(activityParam);
        window.webkit.messageHandlers.setAuth.postMessage(authParam);
      } catch (e) {
        // Native 업데이트 버전 배포와 sync가 맞지 않는 경우 대비 (추후 삭제 예정)
        try {
          window.webkit.messageHandlers.goTo.postMessage(activityParam);
          window.webkit.messageHandlers.moveToHandler.postMessage(action);
          window.webkit.messageHandlers.setAuthHandler.postMessage(authParam);
        } catch (e) {
          console.log('ios Error (' + e.toString() + ')');
        }
      }
      break;
    default:
      console.log('Request startDiagnosis(' + activityParam + '), ');
      break;
  }

  logEvent({
    ga: {
      eventName:
        action === 'MDiagnosis'
          ? 'm_diagnosis_start'
          : 'm_diagnosis_challenge_start',
      eventParam: {},
    },
  });
}

export function updateOS(action, param) {
  switch (platform) {
    case android:
      try {
        window.Becon.requestAction('updateOS', action, param);
      } catch (e) {
        console.log('android Error (' + e.toString() + ')');
      }
      break;
    case ios:
      try {
        window.webkit.messageHandlers.updateOS.postMessage({
          name: 'updateOS',
        });
      } catch (e) {
        console.log('updateOS --- ios Error --- (' + e.toString() + ')');
      }
      break;
    default:
      console.log('Request (' + action + '),' + param + '), ');
      break;
  }
}

export function updateDeviceName(action, param) {
  switch (platform) {
    case android:
      try {
        window.Becon.requestAction('updateDeviceName', action, param);
      } catch (e) {
        console.log('android Error (' + e.toString() + ')');
      }
      break;
    case ios:
    default:
      console.log('Request (' + action + '),' + param + '), ');
      break;
  }
}

export function addKakaoChannel() {
  switch (platform) {
    case android:
      try {
        window.Becon.requestAction(
          'addKakaoChannel',
          'addKakaoChannel',
          JSON.stringify({}),
        );
      } catch (e) {
        console.log('android Error (' + e.toString() + ')');
      }
      break;
    default:
      // ios의 경우, Native 호출 없이 webview에서 처리하고 있음
      try {
        window.Kakao.Channel.addChannel({ channelPublicId: '_WxjsAs' });
      } catch (e) {
        console.log('ios Error (' + e.toString() + ')');
      }
      break;
  }

  if (window.dataLayer) {
    window.dataLayer.push({
      event: 'becon',
      action: 'addKakaoChannel',
    });
  } else {
    logEvent({
      ga: {
        eventName: 'add_kakao_channel',
        eventParam: {},
      },
    });
  }
}

export function chatKakao() {
  console.log('### WEBVIEW ### : ' + JSON.stringify(window.Kakao));
  switch (platform) {
    case android:
      try {
        // 안드로이드의 경우 우선 채널 추가로 동작하고, chat API 추가 후 변경 예정
        window.Becon.requestAction(
          'addKakaoChannel',
          'addKakaoChannel',
          JSON.stringify({}),
        );
      } catch (e) {
        console.log('android addKakaoChannel Error (' + e.toString() + ')');
      }
      break;
    default:
      try {
        window.open('http://pf.kakao.com/_WxjsAs/chat', 'Kakao_chat', 'popup');
        // window.Kakao.Channel.chat({
        //   channelPublicId: '_WxjsAs', // 카카오톡 채널 홈 URL에 명시된 id로 설정합니다.
        // });
      } catch (e) {
        // window.open('http://pf.kakao.com/_WxjsAs/chat', 'Kakao_chat', 'popup');
        console.log('kakao chat open error(' + e.toString() + ')');
      }
      break;
  }

  if (window.dataLayer) {
    window.dataLayer.push({
      event: 'becon',
      action: 'chatKakao',
    });
  } else {
    logEvent({
      ga: {
        eventName: 'chat_kakao',
        eventParam: {},
      },
    });
  }
}

export function sendForeheadToKakaoMsg(
  shareId,
  thumbnailUrl,
  diagnosisType,
  contentType,
) {
  switch (platform) {
    case android:
      try {
        window.Becon.requestAction(
          'shareSocialContent',
          'shareSocialContent',
          JSON.stringify({
            url:
              process.env.REACT_APP_SERVER_BASE_URL === 'stg'
                ? 'http://becon-social.s3-website.ap-northeast-2.amazonaws.com/dev/' +
                  shareId +
                  '?type=' +
                  diagnosisType
                : 'http://becon-social.s3-website.ap-northeast-2.amazonaws.com/' +
                  shareId +
                  '?type=' +
                  diagnosisType,
            img: thumbnailUrl,
            title: 'WithBecon | 위드비컨',
            description: '탈모 관리의 첫 번째, 이마 분석 서비스!',
            btnText: '자세히 보기',
          }),
        );
      } catch (e) {
        console.log('android Error (' + e.toString() + ')');
      }
      break;
    default:
      // Native 호출 없이 webview에서 처리하고 있음
      window.Kakao.Link.sendCustom({
        templateId: 51315,
        templateArgs: {
          THU: thumbnailUrl,
          id:
            process.env.REACT_APP_SERVER_BASE_URL === 'stg'
              ? `dev/${shareId}?type=${diagnosisType}`
              : `${shareId}?type=${diagnosisType}`,
        },
        installTalk: true,
      });
      break;
  }

  logEvent({
    ga: {
      eventName: 'share',
      eventParam: {
        content_type: contentType,
        item_id: shareId,
        channel: 'kakao',
      },
    },
  });
}
// window.Becon.requestAction('handleLogin','handleLogin',"{ method: "kakao" }");
export function handleSocialLogin(serviceName) {
  switch (platform) {
    case android:
      try {
        window.Becon.requestAction(
          'handleLogin',
          'handleLogin',
          JSON.stringify({ method: serviceName }),
        );
      } catch (e) {
        console.log('android Error (' + e.toString() + ')');
      }
      break;
    case ios:
      try {
        window.webkit.messageHandlers.handleLogin.postMessage(
          JSON.stringify({ method: serviceName }),
        );
        console.log('IOS ---------- ----------요청 성공');
      } catch (e) {
        try {
          // Native 업데이트 버전 배포와 sync가 맞지 않는 경우 대비 (추후 삭제 예정)
          window.webkit.messageHandlers.moveToHandler.postMessage(
            'handleKakaoLogin',
          );
        } catch (e) {
          console.log('ios Error (' + e.toString() + ')');
        }
      }
      break;
    default:
      console.log('Request handleSocialLogin');
      break;
  }
}

export function handleLogout() {
  switch (platform) {
    case android:
      try {
        window.Becon.requestAction('logout', 'logout', JSON.stringify({}));
      } catch (e) {
        console.log('android Error (' + e.toString() + ')');
      }
      break;
    case ios:
      try {
        window.webkit.messageHandlers.logout.postMessage('');
      } catch (e) {
        console.log('ios Error (' + e.toString() + ')');
      }
      break;
    default:
      break;
  }
}

export function handleDropout() {
  switch (platform) {
    case android:
      try {
        window.Becon.requestAction('dropout', 'dropout', JSON.stringify({}));
      } catch (e) {
        console.log('android Error (' + e.toString() + ')');
      }
      break;
    case ios:
      try {
        window.webkit.messageHandlers.dropout.postMessage('');
      } catch (e) {
        console.log('ios Error (' + e.toString() + ')');
      }
      break;
    default:
      break;
  }
}

export function getAppInfo() {
  switch (platform) {
    case android:
      try {
        window.Becon.requestAction(
          'getAppInfo',
          'getAppInfo',
          JSON.stringify({}),
        );
      } catch (e) {
        console.log('android Error (' + e.toString() + ')');
      }
      break;
    case ios:
      try {
        // 5.1 web -> ios 호출하여 app version 요청 시
        window.webkit.messageHandlers.getAppInfo.postMessage('version');
      } catch (e) {
        console.log('ios Error (' + e.toString() + ')');
      }
      break;
    default:
      console.log('Request getAppInfo');
      break;
  }
}

export function sendShampooToKakaoMsg() {
  //홈페이지 오픈그래프 이미지
  const imgUrl =
    'https://becon-resources.s3.ap-northeast-2.amazonaws.com/common/image_open_graph_1200x630.png';

  switch (platform) {
    case android:
      try {
        window.Becon.requestAction(
          'shareSocialContent',
          'shareSocialContent',
          JSON.stringify({
            url:
              process.env.REACT_APP_SERVER_BASE_URL === 'stg'
                ? 'https://www.becon-homepage-stg.link'
                : 'https://withbecon.com?utm_source=kakao.message&utm_medium=social&utm_campaign=shampoo',
            img: imgUrl,
            imgWidth: 1200,
            imgHeight: 630,
            btnText: '샴푸 궁합 확인하러 가기',
          }),
        );
      } catch (e) {
        console.log('android Error (' + e.toString() + ')');
      }
      break;
    default:
      window.Kakao.Link.sendCustom({
        templateId:
          process.env.REACT_APP_SERVER_BASE_URL === 'stg' ? 64287 : 62616,
        templateArgs: {
          queryString:
            '?utm_source=kakao.message&utm_medium=social&utm_campaign=shampoo',
        },
        installTalk: true,
      });
      break;
  }

  if (window.dataLayer) {
    window.dataLayer.push({
      event: 'becon',
      action: 'sendShampooToKakaoMsg',
    });
  } else {
    logEvent({
      ga: {
        eventName: 'share',
        eventParam: {
          content_type: 'shampoo',
          channel: 'kakao',
        },
      },
    });
  }
}

export function requestOpenBrowser(url) {
  switch (platform) {
    case android:
      try {
        window.Becon.requestAction(
          'openBrowser',
          '1',
          JSON.stringify({
            url,
          }),
        );
      } catch (e) {
        console.log('android Error (' + e.toString() + ')');
      }
      break;
    case ios:
      try {
        window.webkit.messageHandlers.openBrowser.postMessage(
          JSON.stringify({ url }),
        );
      } catch (e) {
        console.log('ios Error (' + e.toString() + ')');
      }
      break;
    default:
      console.log(' request OpenBrowser ');
      break;
  }
  logEvent({
    ga: {
      eventName: 'open_web_browser',
      eventParam: {},
    },
  });
}

export function getDeviceInfo() {
  switch (platform) {
    case android:
      try {
        window.Becon.requestAction(
          'getDeviceInfo',
          'getDeviceInfo',
          JSON.stringify({}),
        );
      } catch (e) {
        console.log('android Error (' + e.toString() + ')');
      }
      break;
    case ios:
      try {
        window.webkit.messageHandlers.getDeviceInfo.postMessage(
          'getDeviceInfo',
        );
      } catch (e) {
        console.log('ios Error (' + e.toString() + ')');
      }
      break;
    default:
      console.log('Request getDeviceInfo (Only for Android Platform)');
      break;
  }
}
/**   KB 앱내에서 -> 위드비컨 앱으로 이동 한 경우 (KB_USER)  */
export function goToKbCart(products) {
  switch (platform) {
    case android:
      try {
        window.Becon.requestAction(
          'callToKb',
          'callToKb',
          JSON.stringify(products),
        );
      } catch (e) {
        console.log('android Error (' + e.toString() + ')');
      }
      break;
    case ios:
      try {
        window.webkit.messageHandlers.callToKb.postMessage(
          JSON.stringify(products),
        );
      } catch (e) {
        console.log('ios Error (' + e.toString() + ')');
      }
      break;
    default:
      console.log('Request KB CART -> NATIVE REQUEST');
      break;
  }
}
/** 유저가 메인페이지 로드 했을 경우 (로그인 여부 상관 X)  */
export function getFcmToken() {
  switch (platform) {
    case android:
      try {
        window.Becon.requestAction(
          'getFcmToken',
          'getFcmToken',
          JSON.stringify({}),
        );
      } catch (e) {
        console.log('android Error (' + e.toString() + ')');
      }
      break;
    case ios:
      try {
        window.webkit.messageHandlers.getFcmToken.postMessage('');
      } catch (e) {
        console.log('ios Error (' + e.toString() + ')');
      }
      break;
    default:
      break;
  }
}
/** 유저의 핸드폰 환경설정에서 위드비컨 알림설정 off 되어있을 경우 */
export function goToAppSettingView() {
  switch (platform) {
    case android:
      try {
        window.Becon.requestAction(
          'setNotification',
          'setNotification',
          JSON.stringify({}),
        );
      } catch (e) {
        console.log('android Error (' + e.toString() + ')');
      }
      break;
    case ios:
      try {
        window.webkit.messageHandlers.setNotification.postMessage('');
      } catch (e) {
        console.log('ios Error (' + e.toString() + ')');
      }
      break;
    default:
      console.log('Request setNotification ');
      break;
  }
}

/** 유저의 핸드폰 환경설정에서 위드비컨 알림설정된 값 true/false  */
export function getNotification() {
  switch (platform) {
    case android:
      try {
        window.Becon.requestAction(
          'getNotification',
          'getNotification',
          JSON.stringify({}),
        );
      } catch (e) {
        console.log('android Error (' + e.toString() + ')');
      }
      break;
    case ios:
      try {
        window.webkit.messageHandlers.getNotification.postMessage('');
      } catch (e) {
        console.log('ios Error (' + e.toString() + ')');
      }
      break;
    default:
      break;
  }
}
